<template>
  <div class="self-fund-detail-container">
    <div class="bankdetail_title">
      <div class="banktail_">
        <!-- 头部 -->
        <div class="top-line">
          <div class="changeblock">
            <!-- <div>
              <div
                class="historyclass orange"
                v-if="originData.auditState && originData.auditState == '1'"
              >
                审核中
              </div>
              <div
                class="historyclass"
                v-if="originData.auditState && originData.auditState == '2'"
              >
                {{
                  originData.auditTime
                    ? originData.auditTime.substr(0, 10)
                    : ""
                }}
                审核通过
              </div>
            </div> -->
            <div class="project-title">{{ formData.companyName }}</div>
          </div>

        </div>    
        <el-tabs v-model="activeName">
          <el-tab-pane class="activelabel" label="项目详情" name="first">
            <InfoContainer
              :infoTitle="formConfig['infoTitle']"
              :contentConfig="formConfig['infoContent']"
              class="comment-container"
            >
              <CommonDetail
                :configArray="formDetailConfig"
                :initValue="formData"
              />
            </InfoContainer>

            <!-- 投资动态 -->
            <InvestEventManage :ids="$route.params.id" eventBelongType="0" :edit="permission.selfFund_project_manage?true: false"/>
          </el-tab-pane>

        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import InfoContainer from "@/components/infoContainer/fundInfoContainer"
import CommonDetail from "@/components/commonDetail/fundCommonDetail"
import Accessory from "@/components/accessoriesother/fundAccessory"
import InvestEventManage from "../../masterfund/components/invesEventtManage";
import { getSubFundProjectDetail } from "@/api/fund/subfunds"
import {
  detailFormConfig
} from "./config.js";
import { mapGetters } from "vuex";
import util from "@/mixins/util"
export default {
  name: 'SelfFundProjectDetail',
  mixins: [util],
  data() {
    return {
      id: '',
      activeName: 'first',
      formData: '',
      formDetailConfig: detailFormConfig(this.getMoney),
      formConfig: {
        infoTitle: "项目信息",
        infoContent: [
          {
            title: "",
            prop: "basicInfo",
          }
        ],
      },      
    }
  },
  components: {
    Accessory,
    InfoContainer,
    InvestEventManage,
    CommonDetail
  },
  computed: {
    ...mapGetters(["permission"]),
  },  
  mounted() {
    this.id = this.$route.params.id
    this.getDetail()
  },
  methods: {
    async getDetail() {
      this.detailData = {}
      let res = await getSubFundProjectDetail({id: this.id})
      if(res.data.code == 200) {
        let resData = res.data.data
        resData.industryStr = await this.queryDict(resData.industry, '/api/blade-system/dict-biz/dictionary?code=industry_type_all')
        this.formData = resData
      }
    },    
  }
}
</script>
<style lang="scss" scoped>
.self-fund-detail-container{
  .bankdetail_title {
    background: #fff;
    padding-top: 25px;
    padding-bottom: 25px;
    .project-title{
      color: #333;
      font-size: 18px;
      font-weight: bold;
    }    
  }
  .history {
    position: absolute;
    top: 50%;
    right: 15px;
    display: flex;
    justify-content: center;
    z-index: 20;
    flex-direction: row;
    .history_content {
      width: 100px;
      font-size: 14px;
      cursor: pointer;
      height: 45px;
      display: flex;
      flex-direction: row;
      // justify-content: center;
      background: #409eff;
      line-height: 45px;
      color: #fff;
      // text-align: right;
      // padding-right: 15px;
      border-radius: 10px 0 0 10px;
      .imagehistory {
        text-indent: 5px;
        width: 35px;
        display: flex;
        justify-content: center;
        margin-right: 8px;
        flex: 1;
      }
      .text_history {
        flex: 2;
      }
    }
  }
  .banktail_ {
    width: 97%;
    min-width: 1100px;
    margin: 0 auto;
  }
  .bank_nameblock {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    .bankname {
      font-size: 18px;
      font-weight: bolder;
    }
    .changeblock {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      .historyclass {
        background: #19be6b;
        padding: 5px 10px;
        font-size: 10px;
        border-radius: 0 10px 10px 0;
        margin-right: 10px;
        color: #fff;
      }
      .reds {
        background: #f56c6c;
      }
      .orange {
        background: #fec03d;
      }
    }
  }
  .comment-container {
    margin-top: 20px;
    /deep/.detail-one {
      padding-top: 0 !important;
      padding-bottom: 0 !important;
    }
    /deep/.comment-container {
      margin-top: 0 !important;
    }
  }
  .bankcontent {
    position: relative;
    margin: 20px 0;
    .el-col {
      margin-bottom: 0px;
    }
    .grid_content {
      line-height: 35px;
      color: #333333;
      font-size: 14px;
      // margin-bottom: 5px;
      .el-form-item {
        margin-bottom: 0px;
      }

      .banktitle_content {
        color: #999999;
        margin-right: 15px;
      }
      .shstate {
        display: flex;
        flex-direction: row;
        text-align: center;
        justify-content: right;
        .list_top {
          flex: 1;
        }
        .towlist_top {
          text-align: right;
        }
        // .list_top:nth-last-of-type(1){
        //  text-align: right;
        // }

        .stateTop {
          color: rgb(187, 185, 185);
          text-indent: 12px;
        }
        .stateTop + div {
          color: #666666;
          font-size: 20px;
        }
        .stateTopdiv::before {
          content: "";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          margin-right: 5px;
        }
      }
      .data_ {
        margin-top: 25px;
        text-align: right;
        .stateTop {
          color: rgb(187, 185, 185);
        }
        .stateTop + div {
          font-size: 20px;
          font-weight: bolder;
        }
      }
    }
  }

  /deep/.el-form-item__label {
    color: #999999;
  }
  /deep/.el-tabs__header {
    margin: 0px;
  }
  /deep/.banktail_ .el-tabs__item {
    font-size: 18px;
    font-weight: bolder;
    margin-bottom: 10px;
  }
  /deep/ .el-table th {
    background: #fff;
    color: #333;
  }
}
</style>